import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import levelGroupAxios from '../../axios/levelGroup'

export const fetchLevelGroup = filterOptions => {
    return dispatch => {
      const params = {
        ...filterOptions,
        page: filterOptions ? filterOptions.page : 1,
        perPage: filterOptions ? filterOptions.perPage : 10
      }
      dispatch(fetchLevelGroupStart())
      levelGroupAxios
        .get('', { params })
        .then(response => {
          if (response.status === 200 && response.data.success) {
            const { current_page, from, last_page, per_page, to, total, data } = response.data.data
  
            const pagination = {
              currentPage: current_page,
              lastPage: last_page,
              perPage: per_page,
              from,
              to,
              total
            }
  
            const dataWithOption = data.map((item, index) => {
              return { ...item, index: getListingIndex(index, per_page, current_page) }
            })
  
            dispatch(fetchLevelGroupSuccess(pagination, dataWithOption))
          }
        })
        .catch(error => {
          dispatch(fetchLevelGroupFailed(error))
        })
    }
  }
  
  export const fetchLevelGroupStart = () => {
    return {
      type: actionTypes.FETCH_LEVEL_GROUP_START
    }
  }
  
  export const fetchLevelGroupSuccess = (pagination, records) => {
    return {
      type: actionTypes.FETCH_LEVEL_GROUP_SUCCESS,
      pagination,
      records
    }
  }
  
  export const fetchLevelGroupFailed = errorMessage => {
    return {
      type: actionTypes.FETCH_LEVEL_GROUP_FAILED,
      errorMessage
    }
  }

  export const fetchLevelGroupById = recordId => {
    return dispatch => {
      dispatch(fetchLevelGroupStart())
      levelGroupAxios
        .get(`/${recordId}`)
        .then(response => {
          if (response.status === 200) {
            dispatch(fetchLevelGroupByIdSuccess(response.data.data))
          }
        })
        .catch(error => {
          dispatch(fetchLevelGroupFailed(error))
        })
    }
  }
  
  export const fetchLevelGroupByIdSuccess = recordData => {
    return {
      type: actionTypes.FETCH_LEVEL_GROUP_BY_ID_SUCCESS,
      recordData
    }
  }

  export const clearSelectedLevelGroupRecord = () => {
    return {
      type: actionTypes.CLEAR_SELECTED_LEVEL_GROUP_RECORD
    }
  }

  export const createLevelGroup = (recordData, page) => {
    return dispatch => {
      dispatch(createLevelGroupStart())
  
      levelGroupAxios
        .post('', recordData)
        .then(response => {
          if (response.status === 201) {
            dispatch(
              enqueueSnackbar({
                message: 'LevelGroup Created',
                options: {
                  variant: 'success'
                }
              })
            )
            dispatch(createLevelGroupSuccess())
            dispatch(fetchLevelGroup(page))
          }
        })
        .catch(error => {
          switch (error.response.status) {
            case 400:
              dispatch(
                enqueueSnackbar({
                  message: 'Invalid LevelGroup field',
                  options: {
                    variant: 'error',
                    data: error.response.data.data
                  }
                })
              )
              break
  
            default:
              dispatch(
                enqueueSnackbar({
                  message: error.response.data.message,
                  options: {
                    variant: 'error'
                  }
                })
              )
              break
          }
          dispatch(createLevelGroupFailed())
        })
    }
  }
  
  export const createLevelGroupStart = () => {
    return {
      type: actionTypes.CREATE_LEVEL_GROUP_START
    }
  }
  
  export const createLevelGroupSuccess = () => {
    return {
      type: actionTypes.CREATE_LEVEL_GROUP_SUCCESS
    }
  }
  
  export const createLevelGroupFailed = () => {
    return {
      type: actionTypes.CREATE_LEVEL_GROUP_FAILED
    }
  }

  export const updateLevelGroup = (recordId, recordData, page) => {
    return dispatch => {
      dispatch(updateLevelGroupStart())
      levelGroupAxios
        .patch(`/${recordId}`, recordData)
        .then(response => {
          dispatch(
            enqueueSnackbar({
              message: 'LevelGroup Updated',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(updateLevelGroupSuccess())
          dispatch(fetchLevelGroup(page))
        })
        .catch(error => {
          switch (error.response.status) {
            case 400:
              dispatch(
                enqueueSnackbar({
                  message: 'Invalid LevelGroup field',
                  options: {
                    variant: 'error',
                    data: error.response.data.data
                  }
                })
              )
              break
  
            default:
              dispatch(
                enqueueSnackbar({
                  message: error.response.data.message,
                  options: {
                    variant: 'error'
                  }
                })
              )
              break
          }
          dispatch(updateLevelGroupFailed())
        })
    }
  }
  
  export const updateLevelGroupStart = () => {
    return {
      type: actionTypes.UPDATE_LEVEL_GROUP_START
    }
  }
  
  export const updateLevelGroupSuccess = () => {
    return {
      type: actionTypes.UPDATE_LEVEL_GROUP_SUCCESS
    }
  }
  
  export const updateLevelGroupFailed = () => {
    return {
      type: actionTypes.UPDATE_LEVEL_GROUP_FAILED
    }
  }
  
  export const deleteLevelGroup = (recordId, page) => {
    return dispatch => {
      dispatch(deleteLevelGroupStart())
      levelGroupAxios
        .delete(`/${recordId}`)
        .then(response => {
          dispatch(
            enqueueSnackbar({
              message: 'LevelGroup Deleted',
              options: {
                key: recordId,
                variant: 'success'
              }
            })
          )
          dispatch(deleteLevelGroupSuccess())
          dispatch(fetchLevelGroup(page))
        })
        .catch(error => {
          dispatch(
            enqueueSnackbar({
              message: error.response.data.message,
              options: {
                variant: 'error'
              }
            })
          )
          dispatch(deleteLevelGroupFailed())
        })
    }
  }
  
  export const deleteLevelGroupStart = () => {
    return {
      type: actionTypes.DELETE_LEVEL_GROUP_START
    }
  }
  
  export const deleteLevelGroupSuccess = () => {
    return {
      type: actionTypes.DELETE_LEVEL_GROUP_SUCCESS
    }
  }
  
  export const deleteLevelGroupFailed = () => {
    return {
      type: actionTypes.DELETE_LEVEL_GROUP_FAILED
    }
  }

  export const fetchLevelGroupFilterLevelGroup = filter => {
    return dispatch => {
      dispatch(fetchLevelGroupFilterLevelGroupStart())
      levelGroupAxios
        .get('/dropdown', { params: filter })
        .then(response => {
          if (response.status === 200) {
            dispatch(fetchLevelGroupFilterLevelGroupSuccess(response.data.data))
          }
        })
        .catch(error => {
          dispatch(fetchLevelGroupFilterLevelGroupFailed(error?.response?.data?.message))
        })
    }
  }
  
  export const fetchLevelGroupFilterLevelGroupStart = () => {
    return {
      type: actionTypes.FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_START
    }
  }
  
  export const fetchLevelGroupFilterLevelGroupSuccess = data => {
    return {
      type: actionTypes.FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_SUCCESS,
      data
    }
  }
  
  export const fetchLevelGroupFilterLevelGroupFailed = errorMessage => {
    return {
      type: actionTypes.FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_FAILED,
      errorMessage
    }
  }

  export const fetchLevelGroupFilterActive = () => {
    return dispatch => {
      dispatch(fetchLevelGroupFilterActiveStart())
      let active = [
        {
          active_id: 1,
          active_code: 1,
          active_name: 'Active'
        },
        {
          active_id: 0,
          active_code: 0,
          active_name: 'Inactive'
        }
      ]
  
      if (active) {
        dispatch(fetchLevelGroupFilterActiveSuccess(active))
      } else {
        dispatch(fetchLevelGroupFilterActiveFailed('Get active fail'))
      }
    }
  }
  
  export const fetchLevelGroupFilterActiveStart = () => {
    return {
      type: actionTypes.FETCH_LEVEL_GROUP_FILTER_ACTIVE_START
    }
  }
  
  export const fetchLevelGroupFilterActiveSuccess = data => {
    return {
      type: actionTypes.FETCH_LEVEL_GROUP_FILTER_ACTIVE_SUCCESS,
      data
    }
  }
  
  export const fetchLevelGroupFilterActiveFailed = errorMessage => {
    return {
      type: actionTypes.FETCH_LEVEL_GROUP_FILTER_ACTIVE_FAILED,
      errorMessage
    }
  } 

  